import { useContext } from 'react';
import { ContexteA11y, type ContexteAccessibilite } from './contexte';

export function useAccessibilite(): ContexteAccessibilite {
  const contexte = useContext(ContexteA11y);
  if (!contexte) {
    throw new Error('useAccessibilite doit être utilisé dans un FournisseurAccessibilite');
  }
  return contexte;
}
